import Icon from 'veui/components/Icon'
import { IconSortAlt } from 'dls-icons-vue'

Icon.register('sort-alt', IconSortAlt)
